import { EOrderEventType } from './order.interfaces';

export const ORDER_EVENT_PRIORITY: Record<EOrderEventType, number> = {
  [EOrderEventType.created]: 0,
  [EOrderEventType.validated]: 1,
  [EOrderEventType.paymentReserved]: 2,
  [EOrderEventType.paid]: 3,
  [EOrderEventType.entitlementsCreated]: 4,
  [EOrderEventType.securityFeaturesCreated]: 5,
  [EOrderEventType.documentsCreated]: 6,
  [EOrderEventType.emailsSend]: 7,
  [EOrderEventType.salesDataCreated]: 8,
  [EOrderEventType.failed]: 9,
  [EOrderEventType.refunded]: 10,
};
